// services import and CSS
import React, { useState, useCallback } from 'react'
import PrerollsListExt          from './PrerollsListExt'
import PrerollsListVideoExt     from './PrerollsListVideoExt'
import PrerollsPlaylistExt      from './PrerollsPlaylistExt'
import PrerollFormModalExt      from './PrerollsFormModalExt'
import PrerollFormModalVideoExt from './PrerollFormModalVideoExt'

import ParamsListExt            from './ParamsListExt'
import ParamsFormModalExt       from './ParamsFormModalExt'

import '../../css/prerollsTabs.css'

const tabs = ['audio', 'video', 'playlist', 'params']

export default function PrerollsPageExt() {
  const [tab, setTab]         = useState('audio')
  const [show, setShow]       = useState(false)
  const [editing, setEditing] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const openCreate = () => { setEditing(null); setShow(true) }
  const openEdit   = useCallback(r => { setEditing(r); setShow(true) }, [])
  const onSaved    = () => { setRefresh(k => k + 1) }

  return (
    <>
      {/* TAB BAR */}
      <nav className="rr-tabs">
        {tabs.map(t => (
          <button
            key={t}
            className={`rr-tab ${tab === t ? 'active' : ''}`}
            onClick={() => setTab(t)}
          >
            {t.toUpperCase()}
          </button>
        ))}
      </nav>

      {/* LIST */}
      {tab === 'audio' && (
        <PrerollsListExt
          key="audio"
          onEdit={openEdit}
          onChange={onSaved}
          refreshKey={refresh}
        />
      )}

      {tab === 'video' && (
        <PrerollsListVideoExt
          key="video"
          onEdit={openEdit}
          onChange={onSaved}
          refreshKey={refresh}
        />
      )}

      {tab === 'playlist' && (
        <PrerollsPlaylistExt key="playlist" />
      )}

      {tab === 'params' && (
        <ParamsListExt key="params" refreshKey={refresh} />
      )}

      {/* “+” FAB */}
      {tab !== 'playlist' && (
        <button className="fab-add" onClick={openCreate}>＋</button>
      )}

      {/* MODAL */}
      {tab === 'audio' && (
        <PrerollFormModalExt
          open={show}
          editing={editing}
          onClose={() => setShow(false)}
          onSaved={onSaved}
        />
      )}

      {tab === 'video' && (
        <PrerollFormModalVideoExt
          open={show}
          editing={editing}
          onClose={() => setShow(false)}
          onSaved={onSaved}
        />
      )}

      {tab === 'params' && (
        <ParamsFormModalExt
          open={show}
          onClose={() => setShow(false)}
          onSaved={onSaved}
        />
      )}
    </>
  )
}
